import lineStyle from './yAxis.axisLine.lineStyle'

export default {
  name: "axisLine",
  nickname: "坐标轴轴线",
  desc: "坐标轴轴线相关设置。",
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示坐标轴轴线。",
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    onZero: {
      name: "onZero",
      nickname: "onZero",
      desc:
        "X 轴或者 Y 轴的轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。",
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    onZeroAxisIndex: {
      name: "onZeroAxisIndex",
      nickname: "onZeroAxisIndex",
      desc: "当有双轴时，可以用这个属性手动指定，在哪个轴的 0 刻度上。",
    },
    symbol: {
      name: "symbol",
      nickname: "箭头",
      desc:
        '轴线两边的箭头。可以是字符串，表示两端使用同样的箭头；或者长度为 2 的字符串数组，分别表示两端的箭头。默认不显示箭头，即 <code class="codespan">&#39;none&#39;</code>。两端都显示箭头可以设置为 <code class="codespan">&#39;arrow&#39;</code>，只在末端显示箭头可以设置为 <code class="codespan">[&#39;none&#39;, &#39;arrow&#39;]</code>。',
      value: "none",
      defaultValue: "none",
      type: "pureValue",
    },
    symbolSize: {
      name: "symbolSize",
      nickname: "箭头大小",
      desc:
        "轴线两边的箭头的大小，第一个数字表示宽度（垂直坐标轴方向），第二个数字表示高度（平行坐标轴方向）。",
      value: [10, 15],
      defaultValue: [10, 15],
      type: "pureValue",
    },
    symbolOffset: {
      name: "symbolOffset",
      nickname: "箭头偏移",
      desc:
        "轴线两边的箭头的偏移，如果是数组，第一个数字表示起始箭头的偏移，第二个数字表示末端箭头的偏移；如果是数字，表示这两个箭头使用同样的偏移。",
      value: [0, 0],
      defaultValue: [0, 0],
      type: "pureValue",
    },
    lineStyle,
  },
}
